"use client";

import type { Locale } from "@/i18n-config";
import { HeaderBar } from "@/components/header/Bar";
import {
  HeaderAccountView,
  HeaderAccountMobileView,
  type HeaderAccountDictionary,
} from "@/components/header/HeaderAccountView";
import {
  HeaderMain,
  HeaderMainMobile,
} from "@/components/navigation/MainNavigation";
import { useClientAuth } from "@/components/providers/client/AuthProvider";
import { useClientAccount } from "@/components/providers/client/AccountProvider";
import {
  NotificationDrawer,
  type NotificationDictionary,
} from "@/components/notifications/NotificationDrawer";
import {
  filterNavigation,
  type NavigationItem,
} from "@/utils/content/navigation";

export function PublicHeaderNavigation({
  lang,
  className,
  navigation,
  dictionary,
  notificationDictionary,
}: {
  lang: Locale;
  className?: string;
  navigation: NavigationItem[];
  dictionary: HeaderAccountDictionary;
  notificationDictionary: NotificationDictionary;
}) {
  const clientAuth = useClientAuth();
  const { account } = useClientAccount();
  const auth = {
    ...clientAuth,
    user: clientAuth.user ?? null,
    session: clientAuth.session ?? null,
  };
  const items = filterNavigation(navigation, auth);
  return (
    <HeaderBar
      lang={lang}
      className={className}
      homeUrl={auth.isLoggedIn ? "/dashboard" : "/"}
      main={<HeaderMain lang={lang} navigation={items} />}
      mainMobile={<HeaderMainMobile lang={lang} navigation={items} />}
      account={
        <HeaderAccountView
          lang={lang}
          auth={auth}
          account={auth.isLoggedIn ? (account ?? null) : null}
          dictionary={dictionary}
        />
      }
      accountMobile={
        <HeaderAccountMobileView
          lang={lang}
          auth={auth}
          dictionary={dictionary}
        />
      }
      notification={
        auth.isLoggedIn && auth.user ? (
          <NotificationDrawer
            key={auth.user.id}
            locale={lang}
            accountId={auth.user.id}
            dictionary={notificationDictionary}
          />
        ) : null
      }
    />
  );
}
